export const SIZE_LIBELLE_REGROUPEMENT_PERSO = 4000;
export const TYPE_DONNE_EXPORT_RESEAU_NUM_PUBLID = 'reseaunumpublid';

export const TYPE_REFERENCE_EXTERNE_VENTE = 'CommandeVente';
export const TYPE_REFERENCE_EXTERNE_ACHAT = 'CommandeAchat';
export const TYPE_REFERENCE_EXTERNE_COMMANDE_VENTE_AVANCE = 'CommandeVenteAvance';
export const TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT = 'LettrageAPaiement';
export const TYPE_REFERENCE_EXTERNE_FACTURE_FOURNISSEUR = 'FactureFournisseur';
export const TYPE_REFERENCE_EXTERNE_LETTRAGE_FOURNISSEUR = 'LettrageFournisseur';
export const TYPE_REFERENCE_EXTERNE_CA_GARANTI = 'CAGaranti';
export const TYPE_REFERENCE_EXTERNE_REVERSEMENT_GARANTI = 'ReversementGaranti';

export const ALL_TYPE_REFERENCE_EXTERNE = [
  { value: TYPE_REFERENCE_EXTERNE_VENTE, libelle: 'listeCommandeCommissions.referenceExterne.vente' },
  { value: TYPE_REFERENCE_EXTERNE_ACHAT, libelle: 'listeCommandeCommissions.referenceExterne.achat' },
  { value: TYPE_REFERENCE_EXTERNE_COMMANDE_VENTE_AVANCE, libelle: 'listeCommandeCommissions.referenceExterne.avance' },
  { value: TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT, libelle: 'listeCommandeCommissions.referenceExterne.encaissement' },
  { value: TYPE_REFERENCE_EXTERNE_FACTURE_FOURNISSEUR, libelle: 'listeCommandeCommissions.referenceExterne.factureFournisseur' },
  { value: TYPE_REFERENCE_EXTERNE_LETTRAGE_FOURNISSEUR, libelle: 'listeCommandeCommissions.referenceExterne.encaissementFournisseur' },
];

export const ALL_TYPE_REFERENCE_EXTERNE_VENDEUR = [
  { value: TYPE_REFERENCE_EXTERNE_COMMANDE_VENTE_AVANCE, libelle: 'listeCommandeCommissions.referenceExterne.avance' },
  { value: TYPE_REFERENCE_EXTERNE_LETTRAGE_A_PAIEMENT, libelle: 'listeCommandeCommissions.referenceExterne.encaissement' },
];

export const ALL_TYPE_REFERENCE_EXTERNE_FOURNISSEUR = [
  { value: TYPE_REFERENCE_EXTERNE_FACTURE_FOURNISSEUR, libelle: 'listeCommandeCommissions.referenceExterne.factureFournisseur' },
  { value: TYPE_REFERENCE_EXTERNE_LETTRAGE_FOURNISSEUR, libelle: 'listeCommandeCommissions.referenceExterne.encaissementFournisseur' },
];

export const A_VALIDER = 'AValider';
export const A_VERSER = 'AVerser';
export const VERSEE = 'Versee';
export const ANNULEE = 'Annulee';
export const ANNULATION = 'Annulation';

export const PAR_DATE_DEPART = 'dateDebut';
export const PAR_PRODUIT = 'produit.libelle';
export const PAR_LIBELLE = 'libelle';

export const ASC = 'asc';
export const DESC = 'desc';

export const ALL_VENDEUR_ETAT_COMMISSION = [
  { value: A_VALIDER, libelle: 'listeCommandeCommissions.etatCommissions.aValider' },
  { value: A_VERSER, libelle: 'listeCommandeCommissions.etatCommissions.aVerser' },
  { value: VERSEE, libelle: 'listeCommandeCommissions.etatCommissions.versee' },
  { value: ANNULEE, libelle: 'listeCommandeCommissions.etatCommissions.annulee' },
];

export const ALL_FOURNISSEUR_ETAT_COMMISSION = [
  { value: A_VERSER, libelle: 'listeCommandeCommissions.etatCommissions.aVerser' },
  { value: VERSEE, libelle: 'listeCommandeCommissions.etatCommissions.versee' },
  { value: ANNULEE, libelle: 'listeCommandeCommissions.etatCommissions.annulee' },
];

export const ALL_ETAT_COMMISSION = [
  { value: A_VALIDER, libelle: 'listeCommandeCommissions.etatCommissions.aValider' },
  { value: A_VERSER, libelle: 'listeCommandeCommissions.etatCommissions.aVerser' },
  { value: VERSEE, libelle: 'listeCommandeCommissions.etatCommissions.versee' },
  { value: ANNULEE, libelle: 'listeCommandeCommissions.etatCommissions.annulee' },
  { value: ANNULATION, libelle: 'listeCommandeCommissions.etatCommissions.annulation' },
];

export const ALL_TRI_POSSIBLES = [
  { value: PAR_DATE_DEPART, libelle: 'dcf.triLignes.triPossibles.startdate' },
  { value: PAR_PRODUIT, libelle: 'dcf.triLignes.triPossibles.product' },
  { value: PAR_LIBELLE, libelle: 'dcf.triLignes.triPossibles.libelle' },
];

export const ALL_SENS_TRI = [
  { value: ASC, libelle: 'dcf.triLignes.sensTri.ascendant' },
  { value: DESC, libelle: 'dcf.triLignes.sensTri.descendant' },
];

export const EXPORT_EXCEL_COMMISSION = 'commission';
export const EXPORT_EXCEL_TYPE_FOURNISSEUR = 'fournisseur';
export const EXPORT_EXCEL_TYPE_VENDEUR = 'vendeur';

export const EXCLUSION_LIGNE_COMMANDE = 'lignesCommandes';
export const LISTE_EXCLUSION_DCF = [
  { value: EXCLUSION_LIGNE_COMMANDE },
];

export const INCLUSION_TIERS = 'tiers';
export const INCLUSION_LIGNE_COMMANDE = 'lignesCommandes';
export const INCLUSION_LIEU_DE_LIVRAISON = 'lieuDeLivraison';
export const INCLUSION_PRODUIT = 'produit';
export const INCLUSION_ECHEANCIERS = 'echeanciers';
export const INCLUSION_LIGNE_LIEU_DE_LIVRAISON = 'lieuxLivraisons';

export const LISTE_INCLUSION_DCF = [
  { value: INCLUSION_TIERS },
];

export const LISTE_INCLUSION_COMMANDE_ACHAT = [
  INCLUSION_TIERS,
  INCLUSION_LIEU_DE_LIVRAISON,
];
